import { Instagram, Youtube, Facebook, Linkedin, Sparkles } from "lucide-react";
import { SOCIAL_PROOF, EDITORIAL_MARQUEE, BRAND } from "@/data/content";

const ICONS = { Instagram, YouTube: Youtube, Facebook, LinkedIn: Linkedin };

export const SocialProofMarquee = () => {
  const items = [...SOCIAL_PROOF, ...SOCIAL_PROOF];
  return (
    <div className="relative border-y border-white/10 bg-black/60 py-6 overflow-hidden marquee-mask" data-testid="social-proof-marquee">
      <div className="flex w-max animate-marquee gap-14 items-center">
        {items.map((item, i) => {
          const Icon = ICONS[item];
          return (
            <a
              key={`${item}-${i}`}
              href={Icon ? BRAND.socials[item.toLowerCase()] : "#social"}
              target={Icon ? "_blank" : undefined}
              rel="noopener noreferrer"
              data-testid={`social-proof-item-${i}`}
              className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors duration-300 whitespace-nowrap"
            >
              {Icon ? <Icon className="w-5 h-5 text-indigo-400" /> : <Sparkles className="w-4 h-4 text-purple-400" />}
              <span className="font-display text-sm sm:text-base font-semibold uppercase tracking-[0.2em]">{item}</span>
            </a>
          );
        })}
      </div>
    </div>
  );
};

export const EditorialMarquee = () => {
  const items = [...EDITORIAL_MARQUEE, ...EDITORIAL_MARQUEE];
  return (
    <div className="relative py-10 sm:py-16 overflow-hidden marquee-mask" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee-slow gap-10 items-center">
        {items.map((item, i) => (
          <span key={`${item}-${i}`} className="flex items-center gap-10 whitespace-nowrap">
            <span className={`font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold uppercase tracking-tight ${i % 2 === 0 ? "text-outline" : "text-white/90"}`}>
              {item}
            </span>
            <span className="w-3 h-3 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
